module.exports = __webpack_public_path__ + "static/media/Mitsubachi-4.eafff014.jpg";